
export function normalizeError(err: unknown): {
  message: string;
  name?: string;
  stack?: string;
  url?: string;
  ngOriginalError?: any;
  isHttp?: boolean;
  status?: number;
} {
  // HttpErrorResponse
  if (err && typeof err === 'object' && 'status' in err && 'message' in err) {
    const http = err as any;
    return {
      message: http.message ?? 'HttpErrorResponse',
      name: 'HttpErrorResponse',
      stack: http.error?.stack,
      isHttp: true,
      status: http.status,
      ngOriginalError: http.error,
    };
  }

  // Angular sometimes wraps:
  const anyErr = err as any;
  const original = anyErr?.ngOriginalError ?? anyErr?.originalError;

  if (err instanceof Error) {
    return {
      message: err.message,
      name: err.name,
      stack: err.stack,
      ngOriginalError: original,
    };
  }

  // string / object / unknown
  return {
    message: typeof err === 'string' ? err : JSON.stringify(err),
    name: anyErr?.name,
    stack: anyErr?.stack,
    ngOriginalError: original,
  };
}

export function storageWorks(type: 'sessionStorage' | 'localStorage') {
  try {
    const s = window[type];
    const k = '__svh_test__';
    s.setItem(k, '1');
    s.removeItem(k);
    return true;
  } catch {
    return false;
  }
}

export function detectInAppBrowser(ua: string) {
  const u = ua.toLowerCase();
  return (
    u.includes('fbav') ||
    u.includes('fban') || // Facebook
    u.includes('instagram') ||
    u.includes('line/') ||
    u.includes('snapchat') ||
    u.includes('wv') || // Android WebView
    u.includes('gsa/') // Google app iOS
  );
}

export function makeContextProps(extra?: Record<string, any>) {
  const ua = navigator.userAgent ?? '';
  return {
    label: 'svh-configurator',
    href: location.href,
    origin: location.origin,
    path: location.pathname,
    hash: location.hash,
    userAgent: ua,
    isInAppBrowser: String(detectInAppBrowser(ua)),
    sessionStorageOk: String(storageWorks('sessionStorage')),
    localStorageOk: String(storageWorks('localStorage')),
    hasCrypto: String(!!window.crypto),
    hasSubtle: String(!!window.crypto?.subtle),
    ...extra,
  };
}
